import { useMutation } from "@apollo/client";
import { parseError } from "apollo";
import Button from "components/base/Button";
import { Input } from "components/base/Form";
import { Alert } from "components/base/Toast";
import { useEffect, useRef, useState } from "react";
import { CREATE_TAG, DELETE_TAG, UPDATE_TAG } from "./graphql";

const EditTagView = ({ id, category, initialValues, hide }) => {
  const [value, setValue] = useState(initialValues?.value || "");
  const inputRef = useRef(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      inputRef.current?.focus();
    }, 50);

    return () => clearTimeout(timer);
  }, []);

  const [create, createRes] = useMutation(CREATE_TAG, {
    onCompleted() {
      Alert("success", "Tag Created.");
      hide();
    },
    onError(error) {
      window.alert(parseError(error));
    },
  });
  const [save, saveRes] = useMutation(UPDATE_TAG, {
    onCompleted() {
      Alert("success", "Tag Updated.");
      hide();
    },
    onError(error) {
      window.alert(parseError(error));
    },
  });
  const [deleteTag, deleteRes] = useMutation(DELETE_TAG, {
    onCompleted() {
      Alert("success", "Tag Deleted.");
      hide();
    },
    onError(error) {
      window.alert(parseError(error));
    },
  });

  return (
    <div className="text-sm">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          if (id) {
            save({ variables: { id, value } });
          } else {
            create({ variables: { categoryId: category?.id, value } });
          }
        }}
      >
        <Input
          ref={inputRef}
          className="w-full"
          placeholder="Tag Value"
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />

        <div className="mt-6">
          {id ? (
            <div className="flex justify-between items-center">
              <Button
                type="submit"
                primary
                onClick={() => save({ variables: { id, value } })}
                loading={saveRes.loading}
              >
                Save
              </Button>
              <Button
                danger
                onClick={() => deleteTag({ variables: { id } })}
                loading={deleteRes.loading}
              >
                Delete
              </Button>
            </div>
          ) : (
            <Button
              type="submit"
              primary
              onClick={() =>
                create({ variables: { categoryId: category?.id, value } })
              }
              loading={createRes.loading}
            >
              Create
            </Button>
          )}
        </div>
      </form>
    </div>
  );
};

export default EditTagView;
